import React from 'react';
const items = ['Te sentís insatisfecha con tu trabajo o rutina actual', 'Querés dejar de vivir limitada y generar ingresos REALES', 'Te sentís estancada, bloqueada e improvisando'];
export function BeforeSection() {
  return <section className="px-8 py-14 bg-[#fce4e4] flex flex-col items-center text-center w-full" data-id="element-11">
      <div className="max-w-7xl mx-auto" data-id="element-12">
        <h2 className="font-serif text-3xl md:text-5xl text-red-600 mb-10" data-id="element-13">
          Antes de Fórmula UGC
        </h2>

        <ul className="w-full grid grid-cols-1 md:grid-cols-3 gap-8 text-left max-w-5xl mx-auto" data-id="element-14">
          {items.map((item, i) => <li key={i} className="flex items-start gap-3 bg-white/50 p-6 rounded-2xl shadow-sm" data-id="element-15">
              <span className="text-xl shrink-0 leading-tight" data-id="element-16">❌</span>
              <span className="font-serif text-brand-navy text-[18px] md:text-xl leading-snug" data-id="element-17">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}